import { useState } from "react";
import { Link } from "react-router-dom";
import * as api from "../lib/api.js";
import * as s from "../styles.js";

export function ForgotPasswordPage(): JSX.Element {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [devToken, setDevToken] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    const res = await api.forgotPassword(email);
    setMessage(res.message);
    // dev_only_reset_token is only ever present outside production (see
    // services/api/app/routers/auth.py) — this build has no outbound email
    // sending, documented in docs/known-limitations.md.
    setDevToken(res.dev_only_reset_token ?? null);
  }

  return (
    <div style={s.container}>
      <h1 style={s.heading1}>Forgot your password?</h1>
      <form onSubmit={(e) => void handleSubmit(e)} style={{ maxWidth: 360 }}>
        <label style={s.label}>
          Email
          <input style={s.input} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <button type="submit" style={s.buttonPrimary}>
          Send reset link
        </button>
      </form>
      {message && <p style={{ ...s.mutedText, marginTop: 16 }}>{message}</p>}
      {devToken && (
        <div style={{ ...s.card, marginTop: 16 }}>
          <p style={s.mutedText}>
            This EduFadder deployment has no outbound email sending configured yet, so here is the reset link directly
            (dev/non-production only):
          </p>
          <p>
            <Link to={`/reset-password?token=${encodeURIComponent(devToken)}`}>Reset your password</Link>
          </p>
        </div>
      )}
    </div>
  );
}
